// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","img-container":"Card_img-container__tgsdV","img":"Card_img__8Ehvv","chip-container":"Card_chip-container__D52cd"};